import { render, staticRenderFns } from "./ListSuppliersPage.vue?vue&type=template&id=72b6c3a1"
import script from "./ListSuppliersPage.vue?vue&type=script&lang=js"
export * from "./ListSuppliersPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports